module.exports = __webpack_public_path__ + "img/inception.8530f24c.png";